import React from "react";
import BuildnewPartnership from "web/assets/images/build-new-partnership.png";
import QualifiedSellers from "web/assets/images/qualified-sellers.png";
import BuyersSellers from "web/assets/images/buyers-sellers.png";
import YourNewEcommerceDesk from "web/assets/images/your-new-ecommerce-desk.png";
import PrivacyProtected from "web/assets/images/privacy-protected.png";
import { useHistory } from 'react-router-dom';

import {
  Container,
  Wrapper,
  GroupSection,
  BoxSection,
} from "web/pages/public/landing-page/WhoItFor/PalletBroker/PalletBrokerStyled";
const Data = [
  // {
  //   id: 1,
  //   heading: "Build New Partnerships",
  //   subHeading:
  //     "Buyers can identify and qualify new supply resources, while eliminating the inefficiency of travel, discovery, and recruitment.",
  //   src: `${BuildnewPartnership}`,
  // },
  // {
  //   id: 2,
  //   heading: "Qualified Sellers",
  //   subHeading:
  //     "PalletTrader will qualify sellers. Our vetting process ensures members are the highest-quality trading partners.",
  //   src: `${QualifiedSellers}`,
  // },
  {
    id: 2,
    heading: "Your New Ecommerce Desk",
    subHeading:
      "PalletTrader is your new platform for selling. No cold calls or sales force needed. Buy or sell any time, anywhere.",
    src: `${YourNewEcommerceDesk}`,
  },
  {
    id: 3,
    heading: "Privacy Protected",
    subHeading:
      "To ensure privacy, brokers will have their own unique profile. Buy or sell without disclosing your customers or sources.",
    src: `${PrivacyProtected}`,
  },
  {
    id: 1,
    heading: "Buyers & Sellers Qualified",
    subHeading:
      "PalletTrader will qualify buyers and sellers. Our vetting process ensures members are the highest-quality trading partners.",
    src: `${BuyersSellers}`,
  },
 
 
];

const PalletBroker = () => {
  let history = useHistory();
  const signUp = () => {
    history.push('/registration')
    
  }
return(
  <Container data-aos="fade-up" data-aos-delay="400">
    <Wrapper>
      <h4 className="blue-text">Pallet Broker.</h4>
      <h4>Say hello to the newest member of your sales team.</h4>
      <h5>
      Pallet brokers now have their own platform to identify and build new relationships. Generate a steady flow of inexpensive supply partners. Say goodbye to the trial and error inefficiency of boots-on-the-ground recruitment. And be secure knowing your new partners have been vetted.
      </h5>
      <GroupSection>
        {Data.map((e) => {
          return (
            <BoxSection key={e.id}>
              <img src={e.src} alt="NounPins" />
              {e.id ===2?<h6 style={{"margin-top":"15px"}}>{e.heading}</h6>:<h6>{e.heading}</h6>}
              <p>{e.subHeading}</p>
            </BoxSection>
          );
        })}
      </GroupSection>
      <button onClick={signUp}>Sign Me Up</button>
    </Wrapper>
  </Container>
);
      }
export default PalletBroker;
